import { css } from '@emotion/react';

export const submitButtonSubmittingStyles = css`
  & .MuiButton-label {
    visibility: hidden;
  }
`;

export const submitButtonIconStyles = css`
  position: absolute;
  visibility: visible;
`;
